var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38464 12.5601H10.3119C10.8418 12.5601 11.2755 12.1265 11.2755 11.5965C11.2755 11.0665 10.8418 10.6329 10.3119 10.6329H8.38464C7.85466 10.6329 7.42103 11.0665 7.42103 11.5965C7.42103 12.1265 7.85466 12.5601 8.38464 12.5601ZM0.675781 1.96043C0.675781 2.49042 1.1094 2.92404 1.63939 2.92404H17.0571C17.5871 2.92404 18.0207 2.49042 18.0207 1.96043C18.0207 1.43045 17.5871 0.996826 17.0571 0.996826H1.63939C1.1094 0.996826 0.675781 1.43045 0.675781 1.96043ZM4.53021 7.74208H14.1663C14.6963 7.74208 15.1299 7.30846 15.1299 6.77847C15.1299 6.24849 14.6963 5.81486 14.1663 5.81486H4.53021C4.00023 5.81486 3.5666 6.24849 3.5666 6.77847C3.5666 7.30846 4.00023 7.74208 4.53021 7.74208Z",
    fill: "#9A9AB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger_menu.406c6b2aead9aaf25176ecf03242f9bd.svg";
export { ForwardRef as ReactComponent };